export default __webpack_public_path__ + "static/media/employee_upload_format.4d4a2638.csv";